var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[_c('large-button',{on:{"click":function($event){_vm.$router.push('home')}}},[_vm._v("\n      Home\n    ")])],1),_vm._v(" "),(_vm.help)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.help.htmlcontent)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7547b74f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TANDCS.vue
// module id = 452
// module chunks = 1